<template>
  <ul
    class="ah-list"
    :class="classObj"
  >
    <slot />
  </ul>
</template>
<script>
  export default {
    props: {
      /**
       * @param {String} flexDirectionClass flex-direction class property
       * Default value is set to ah-list-column meaning flex-direction: column
       * Values : ah-list-column, ah-list-row
       */
      column: {
        default: true,
        type: Boolean,
      },
      /**
       * @param {String} marge gap property
       * If set to md or medium, gap = 8px
       * If set to lg or large, gap = 12px
       */
      marge: {
        type: String,
        default: 'md',
        validator: (marge) => ['md', 'medium', 'lg', 'large'].includes(marge),
      },
    },
    computed: {
      classObj() {
        let classes = '';
        classes += !this.column ? 'ah-list--responsive' : '';
        if (this.marge) {
          classes += ['md', 'medium'].includes(this.marge)
            ? ' ah-list-medium'
            : ' ah-list-large';
        }
        return classes;
      },
    },
  };
</script>
